import { LogModel } from './../models/log.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable} from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class LogService {
    constructor(private http: HttpClient) { }

    public getLogs(sid: string): Observable<LogModel[]>{
        return this.http.get('./assets/database.json')
            .pipe(map((databse: any) => {
                if (databse != null) {
                    for (const log of databse.records) {
                        if (log.sid === sid) {
                            return (log.logs);
                        }
                    }
                    throw new Error(`No logs for this sessionId: ${sid} were found`);
                }
                return EMPTY;
            }));
    }

}
